import styled from 'styled-components';

export const StyledSideMenu = styled.div`
  .side-menu {
    position: fixed;
    z-index: 5;
    left: 0;
    top: 0;
    height: 100%;
    width: 0;
    background-color: rgba(0, 0, 0, 0.75);
    opacity: 0;
    visibility: hidden;
    transition: all ease 0.8s;

    &__content {
      background-color: ${({ theme }) => theme.colors.codGray};
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 450px;
      margin-right: auto;
      padding: 120px 30px 30px;
      height: 100%;
      overflow-y: auto;
      position: relative;
      left: -500px;
      cursor: auto;
      transition-delay: 1s;
      transition: left ease 1s;

      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.1);
        box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.1);
        background-color: ${({ theme }) => theme.colors.raven};
      }

      &::-webkit-scrollbar {
        width: 2px;
        background-color: ${({ theme }) => theme.colors.raven};
      }

      &__close-button {
        display: inline-block;
        border: 2px solid;
        width: 50px;
        height: 50px;
        line-height: 50px;
        font-size: 24px;
        padding: 0;
        position: absolute;
        top: 20px;
        right: 20px;
        background-color: ${({ theme }) => theme.colors.white};
        border-radius: 50%;
        transform: rotate(0);
        transition: all ease 0.4s;

        &:hover {
          color: ${({ theme }) => theme.colors.mainOrange};
          border-color: ${({ theme }) => theme.colors.mainOrange};
          transform: rotate(90deg) scale(1.1);
        }
      }

      &__account {
        margin-top: 16px;

        .ant-divider {
          background: ${({ theme }) => theme.colors.raven};
          margin: 0 0 8px;
        }

        &__items {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        &__item {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 10px 8px;
          border-radius: 8px;
          cursor: pointer;
          transition: background-color 0.2s;

          p {
            color: ${({ theme }) => theme.colors.white};
            text-transform: uppercase;
          }

          &:hover {
            background-color: ${({ theme }) => theme.colors.getTransparentColor(theme.colors.white, 0.1)};

            p,
            span {
              color: ${({ theme }) => theme.colors.mainOrange};
            }
          }

          &--logout {
            margin-top: 8px;

            &:hover {
              p,
              span {
                color: ${({ theme }) => theme.colors.error};
              }
            }
          }
        }

        &__icon {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          width: 20px;
          color: ${({ theme }) => theme.colors.white};
          transition: color 0.2s;
        }
      }

      &__auth {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &__item {
          padding-top: 15px;

          .ant-divider {
            background: ${({ theme }) => theme.colors.white};
            margin: 0;
          }
        }
      }
    }

    &--is-open {
      opacity: 1;
      visibility: visible;
      width: 100%;
      transition: all ease 0.8s;

      .side-menu__content {
        left: 0;
        opacity: 1;
        visibility: visible;
      }
    }
  }

  @media (max-width: 767px) {
    .side-menu {
      &__content {
        width: 320px;
        padding: 80px 24px 24px;

        &__close-button {
          width: 40px;
          height: 40px;
          line-height: 40px;
          font-size: 20px;
          top: 16px;
          right: 16px;
        }

        &__account {
          &__item {
            padding: 8px;
            gap: 10px;

            p {
              font-size: 0.85rem;
            }
          }

          &__icon {
            font-size: 14px;
          }
        }
      }

      .custom-menu {
        gap: 14px;

        p {
          font-size: 0.9rem;
        }
      }
    }
  }

  @media (max-width: 400px) {
    .side-menu {
      &__content {
        width: 280px;
        padding: 64px 20px 20px;
      }

      .custom-menu {
        gap: 10px;

        p {
          font-size: 0.8rem;
        }
      }

      .side-menu__content__account__item p {
        font-size: 0.78rem;
      }
    }
  }

  @media screen and (min-width: 1050px) {
    .side-menu {
      display: none;
    }
  }
`;
